const jQuery = window.jQuery;

if (!jQuery) {
  throw new Error('jQuery must be loaded before application scripts');
}

export default jQuery;
